import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterDropdownContentListCategoryContent from './VeltCommentsSidebarV2FilterDropdownContentListCategoryContent/VeltCommentsSidebarV2FilterDropdownContentListCategoryContent';
var VeltCommentsSidebarV2FilterDropdownContentListCategory = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-category-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterDropdownContentListCategory.Content = VeltCommentsSidebarV2FilterDropdownContentListCategoryContent;
export default VeltCommentsSidebarV2FilterDropdownContentListCategory;
